var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.833 10a9.167 9.167 0 1 1 18.334 0A9.167 9.167 0 0 1 .833 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.167c.46 0 .833.373.833.833v3.333a.833.833 0 1 1-1.666 0V10c0-.46.373-.833.833-.833m.833-2.5a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0"
  }))));
};
export default SvgInformation;